module.exports = __webpack_public_path__ + "static/meat-cebf592c53007500ac0b1d9959ecda3a.svg";